import { Injectable } from '@angular/core';

export interface Message {
  message: string;
  type: string;
}

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages: Message[] = [];

  add(message: string, type?: string) {
    const msg = { message: message, type: type };
    this.messages.push(msg);
  }

  clear() {
    this.messages = [];
  }
}
